function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotePost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#6e95ff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.56,9c0,.45-.37,.81-.81,.81h-1.88v1.88c0,.45-.36,.81-.81,.81s-.81-.36-.81-.81v-1.88h-1.88c-.44,0-.81-.36-.81-.81s.37-.81,.81-.81h1.88v-1.88c0-.44,.37-.81,.81-.81s.81,.37,.81,.81v1.88h1.88c.44,0,.81,.37,.81,.81Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.78,14.42h-2.55c-2.47,0-3.63-1.27-3.63-3.98v-2.86c0-2.75,1.12-3.98,3.63-3.98h2.55c2.51,0,3.63,1.23,3.63,3.98v2.86c0,2.75-1.12,3.98-3.63,3.98Zm-2.55-9.53c-1.54,0-2.33,.42-2.33,2.68v2.86c0,2.27,.78,2.68,2.33,2.68h2.55c1.54,0,2.33-.42,2.33-2.68v-2.86c0-2.27-.78-2.68-2.33-2.68h-2.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09,8.22h-3.19c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3.19c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.09,11.08h-3.19c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3.19c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z",
    style: {
      fill: "#fff"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotePost);
export default __webpack_public_path__ + "static/media/note_post.89c69d56df7f86e7d5679553ed8020f2.svg";
export { ForwardRef as ReactComponent };